const Config = {
  GIS: {
    clientId: process.env.REACT_APP_GIS_CLIENT_ID
  },
  MSAL: {
    clientId: process.env.REACT_APP_AZURE_CLIENT_ID,
    authority: process.env.REACT_APP_AZURE_AUTHORITY,
    redirectUri: process.env.REACT_APP_AZURE_REDIRECT_URI,
    scopes: [
      'User.Read'
    ]
  },
  STRIPE: {
    PK: process.env.REACT_APP_STRIPE_PK
  }
}

export default Config
